import { z } from 'zod';

export const InstrumentsUIUniverses = [
  'US-STOCKS',
  'EU-STOCKS',
  'CRYPTO',
  'MUTUAL-FUNDS',
  'NONE',
] as const;
export const ZodInstrumentsUIUniverses = z.enum(InstrumentsUIUniverses);
export type InstrumentsUniverses = z.infer<typeof ZodInstrumentsUIUniverses>;
